<template>
    <!-- No browser context menu on the plate UI -->
    <div v-on:contextmenu.prevent>
        <v-alert
            border="start"
            density="compact"
            style="margin: 10px 20px"
            type="warning"
            v-if="sampleTypes.length === 0"
        >
            The benchling protocol associated with this experiment does not share any sample types
            with the functional protocol
        </v-alert>
        <table class="well-container">
            <thead>
                <v-icon @click="toggleAll">$arrow-bottom-right</v-icon>
                <th
                    v-for="(notInUse, colIndex) in layout[0]"
                    :key="colIndex"
                    @click="toggleColSelection(colIndex)"
                >
                    <span>+</span>
                </th>
            </thead>
            <tbody>
                <tr v-for="(row, rowIndex) in layout" :key="rowIndex">
                    <td>
                        <span @click="toggleRowSelection(rowIndex)">+</span>
                    </td>
                    <td v-for="(cell, colIndex) in row" :key="colIndex">
                        <well :col="colIndex" :row="rowIndex" :batchMap="batchMap" />
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import { defineComponent } from "vue";

import { mapActions, mapGetters } from "vuex";
import Well from "./Well";
import axios from "../../lib/apiAxios";
import _ from "lodash";

export default defineComponent({
    name: "PlateLayout",
    // props: ["value"],
    components: { Well },

    computed: {
        ...mapGetters("plateCreate", [
            "layout",
            "plateWellSelection",
            "sampleTypes",
            "isMultiAssign",
        ]),
    },

    async created() {
        // Fetch map for batch names
        const batchData = await axios.get(`/requests/samp_batchmap`);
        this.batchMap = new Map(batchData.data);
    },

    data() {
        return {
            batchMap: undefined,
        };
    },

    methods: {
        ...mapActions("plateCreate", [
            "togglePlateSelection",
            "clearPlateSelection",
            "selectAllPlateSelection",
        ]),

        toggleAll() {
            if (this.plateWellSelection.length > 0) {
                this.clearPlateSelection();
            } else {
                this.selectAllPlateSelection();
            }
        },

        toggleRowSelection(row) {
            // Select Row - filter controls & blanks
            const colIds = this.layout
                .flat()
                .filter(
                    (well) =>
                        well.row === row &&
                        _.get(well, "sampleType.name") !== "control" &&
                        !well.isBlank
                )
                .map((well) => well.id);
            const unselectedWells = _.difference(colIds, this.plateWellSelection);
            if (unselectedWells.length) {
                unselectedWells.forEach((well) => this.togglePlateSelection(well));
            } else {
                colIds.forEach((well) => this.togglePlateSelection(well));
            }
        },

        toggleColSelection(col) {
            // Select Column - filter controls & blanks
            const colIds = this.layout
                .flat()
                .filter(
                    (well) =>
                        well.col === col &&
                        _.get(well, "sampleType.name") !== "control" &&
                        !well.isBlank
                )
                .map((well) => well.id);
            const unselectedWells = _.difference(colIds, this.plateWellSelection);
            if (unselectedWells.length) {
                unselectedWells.forEach((well) => this.togglePlateSelection(well));
            } else {
                colIds.forEach((well) => this.togglePlateSelection(well));
            }
        },
    },
});
</script>

<style scoped>
.well-container {
    border-spacing: 10px;
    width: 100%;
}

.well-container th:hover {
    cursor: pointer;
}

.well-container td {
    text-align: center;
}
</style>
